import React from 'react';
import { AppointmentForm } from '@/components/service/AppointmentForm';
import './page-layout.css';

export default function ServiceAppointmentPage() {
  return (
    <div className="page">
      <div className="page__container">
        <div className="page__header">
          <h1 className="page__title">Schedule service</h1>
          <p className="page__lead">Book your appointment in just a few steps</p>
        </div>

        <AppointmentForm />
      </div>
    </div>
  );
}
